import { z } from 'zod';

// =============================================================================
// Admin operator-skill distribution — `wayai admin skill install`.
//
// Private platform-operator skills (e.g. `wayai-admin`) are excluded from the
// public skill mirror, so they can't be installed via `npx skills add`. Instead
// they're served from a platform-admin-gated backend route and written into the
// operator's current repo. The skill content is bundled into the BACKEND (never
// the public `@wayai/cli` npm package), so this is the only leak-safe channel.
// =============================================================================

export const ADMIN_SKILL_NAME_REGEX = /^[a-z0-9][a-z0-9-]{0,63}$/;
export const adminSkillNameParam = z.object({
  name: z.string().regex(ADMIN_SKILL_NAME_REGEX, 'invalid skill name'),
});

export interface AdminSkillResponse {
  name: string;
  // relative path within the skill folder -> file content (e.g. "SKILL.md").
  files: Record<string, string>;
}
